module.exports = __webpack_public_path__ + "img/40_38_070_820.8bbe28b0.jpg";